<div class="w-full relative" style="height: 50vw; max-height: 360px" #chartContainer>
    <canvas #chartCanvas></canvas>
</div>
